import React from 'react';
import { 
  FileCheck, 
  Brain, 
  CheckCircle, 
  Zap 
} from 'lucide-react';
import '../css/SectionThree.css'

interface FeatureCard {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const SectionThree: React.FC = () => {
const features: FeatureCard[] = [
  {
    icon: <FileCheck size={64} color="#72d6ff" strokeWidth={2} />,
    title: 'Captures data instantly',
    description: 'Ingests documents, emails, and forms in real time - no manual data entry.'
  },
  {
    icon: <Brain size={64} color="#72d6ff" strokeWidth={2} />,
    title: 'Understands & decides',
    description: 'Uses AI to analyse claim details, detect anomalies and make instant decisions.'
  },
  {
    icon: <CheckCircle size={64} color="#72d6ff" strokeWidth={2} />,
    title: 'Resolves & communicates',
    description: 'Captures, flags or process claims autonomously into your system - notifying teams and customers instantly.'
  },
  {
    icon: <Zap size={64} color="#72d6ff" strokeWidth={2} />,
    title: 'Learns & improves',
    description: 'Continuously learns from every task completed, improving speed and accuracy over time.'
  }
];

  return (
    <>
      <div className="section-three-container">
        {/* Background elements */}
        <div className="bg-squares">
          {[...Array(30)].map((_, i) => (
            <div
              key={i}
              className="floating-square"
              style={{
                width: `${Math.random() * 15 + 5}px`,
                height: `${Math.random() * 15 + 5}px`,
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 20}s`,
                animationDuration: `${15 + Math.random() * 10}s`,
              }}
            />
          ))}
        </div>

        {/* Wave lines SVG */}
        <svg className="wave-lines" viewBox="0 0 1000 1000" preserveAspectRatio="none">
          <path d="M0,200 Q250,100 500,200 T1000,200" stroke="#72d6ff" strokeWidth="1" fill="none" opacity="0.3"/>
          <path d="M0,400 Q250,300 500,400 T1000,400" stroke="#72d6ff" strokeWidth="1" fill="none" opacity="0.3"/>
          <path d="M0,600 Q250,500 500,600 T1000,600" stroke="#72d6ff" strokeWidth="1" fill="none" opacity="0.3"/>
          <path d="M0,800 Q250,700 500,800 T1000,800" stroke="#72d6ff" strokeWidth="1" fill="none" opacity="0.3"/>
        </svg>

        {/* Glow orbs */}
        <div className="glow-orb glow-orb-1" />
        <div className="glow-orb glow-orb-2" />

        <div className="content-wrapper-three">
          {/* Header */}
          <div className="section-three-header">
            <h2 className="section-three-title">
              Solves bottlenecks in the claims process
            </h2>
          </div>

          {/* Features Grid */}
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="cta-section">
            {/* <h2 className="cta-title">How it works:</h2>
            <p className="cta-subtitle">
              Zero – touch, fraud-aware, fully accountable
            </p> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionThree;